import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../../environments/environment";
import {
  Trip,
  TripAttachRequest,
  TripDocsSendResponse,
  TripInfoResponse,
  TripPointParcel,
  TripSearchFilters,
  TripSearchResponse,
  TripStatusTotals,
  TripTransportDocumentItem,
} from "../interfaces/trip.interfaces";
import { Carrier, Dealer } from "../interfaces/anagraphic.interfaces";
import { ClientsBrands } from "./routing.service";

@Injectable({
  providedIn: "root",
})
export class TripService {
  private baseUrl = `${environment.apiUrl}/trips`;

  constructor(private http: HttpClient) {}

  search(filters: TripSearchFilters): Observable<TripSearchResponse> {
    return this.http.post<TripSearchResponse>(
      `${this.baseUrl}/search`,
      filters,
    );
  }

  searchStatusTotals(filters: TripSearchFilters): Observable<TripStatusTotals> {
    return this.http.post<TripStatusTotals>(
      `${this.baseUrl}/search/status-totals`,
      filters,
    );
  }

  getById(tripId: number): Observable<Trip> {
    return this.http.get<Trip>(`${this.baseUrl}/${tripId}`);
  }

  getParcelsByTrip(tripId: number): Observable<TripTransportDocumentItem[]> {
    return this.http.get<TripTransportDocumentItem[]>(
      `${this.baseUrl}/${tripId}/items`,
    );
  }

  getParcelsByTripPoint(tripPointId: number): Observable<TripPointParcel[]> {
    return this.http.get<TripPointParcel[]>(
      `${this.baseUrl}/points/${tripPointId}/parcels`,
    );
  }

  requestTripDocsSend(tripId: number): Observable<TripDocsSendResponse> {
    return this.http.post<TripDocsSendResponse>(
      `${this.baseUrl}/${tripId}/request-docs-send`,
      {},
    );
  }

  exportExcel(filters: TripSearchFilters): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/export`, filters, {
      responseType: "blob",
    });
  }

  printDDTFromTransportDocuments(
    transportDocumentIds: number[],
  ): Observable<Blob> {
    return this.http.post(
      `${this.baseUrl}/printDDT`,
      { transportDocumentIds },
      { responseType: "blob" },
    );
  }

  printTransportDocuments(transportDocumentIds: number[]): Observable<Blob> {
    return this.http.post(
      `${this.baseUrl}/print`,
      { transportDocumentIds },
      { responseType: "blob" },
    );
  }

  resolveTripLink(request: TripAttachRequest): Observable<TripInfoResponse> {
    return this.http.post<TripInfoResponse>(
      `${this.baseUrl}/resolve-link`,
      request,
    );
  }

  attachLoadingListToTrip(
    request: TripAttachRequest,
  ): Observable<TripInfoResponse> {
    return this.http.post<TripInfoResponse>(
      `${this.baseUrl}/attach-loading-list`,
      request,
    );
  }

  detachLoadingListFromTrip(
    request: TripAttachRequest,
  ): Observable<TripInfoResponse> {
    return this.http.post<TripInfoResponse>(
      `${this.baseUrl}/detach-loading-list`,
      request,
    );
  }

  loadCarriers(): Observable<Carrier[]> {
    return this.http.get<Carrier[]>(`${this.baseUrl}/carriers`);
  }

  loadDealers(clientsBrands: ClientsBrands[]): Observable<Dealer[]> {
    return this.http.post<Dealer[]>(
      `${this.baseUrl}/dealers-all-anagraphic`,
      clientsBrands,
    );
  }

  printDDTByTransportDocument(
    transportDocumentIds: number[],
  ): Observable<Blob> {
    return this.http.post(
      `${this.baseUrl}/printSingleDDT`,
      { transportDocumentIds },
      { responseType: "blob" },
    );
  }

  setLoadingListTraction(
    loadingListId: number,
    info: {
      tripPointCarrierCode: string;
      tripPointTractorPlateNo: string;
      tripPointDriverName: string;
    },
  ): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/trips/loading-lists/${loadingListId}/traction`,
      info,
    );
  }
}
